// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MapProviderContainer__closeContainer__l9V-e {
    display: flex;
    position: absolute;
    width: 16px;
    height: 16px;
    top: 15px;
    right: 16px;
}

.MapProviderContainer__closeModalButton__6d9dI {
    display: inline-block;
    top: 16px;
    right: 16px;
    background-image: url("data:image/svg+xml,%3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!----%3E%3Ctitle%3Eicon-close%3C/title%3E%3Cdesc%3E.%3C/desc%3E%3Cg id='icon-close' stroke='none' stroke-width='1' fill='%23000000' fill-rule='evenodd'%3E%3Cpath d='M6.54545455,8 L-1.59738889e-12,1.45454545 L1.45454545,-1.6442403e-12 L8,6.54545455 L14.5454545,1.65201186e-12 L16,1.45454545 L9.45454545,8 L16,14.5454545 L14.5454545,16 L8,9.45454545 L1.45454545,16 L-1.60249591e-12,14.5454545 L6.54545455,8 Z' id='Combined-Shape' fill='%236c6c6c'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 16px 16px;
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.MapProviderContainer__closeButton__La7s6 {
    text-align: center;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10001;
    opacity: 0;

}

.MapProviderContainer__blockTitle__ROnd1 {
    font: 13px/1em 'Open Sans', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px;
    text-transform: capitalize;
    /*margin-top: 16px;*/
    /*margin-left: 16px;*/
}
.MapProviderContainer__blockLargeFontTitle__cgMKi {
    font-size: 16px;
}
.MapProviderContainer__blockTitleDefaultCase__zS16w{
    text-transform: initial;
}

.MapProviderContainer__mapProviderContainer__q1NNw {
    display: flex;
    justify-content: space-around;
    padding: 16px;
    border-bottom: 1px solid var(--color-lightui-surface-4);
}

.MapProviderContainer__mapProviderDropdown__YnPBB {
    position: relative;
    z-index: 10001;
}

.MapProviderContainer__mapTypeContainer__LTCpg {
    display: flex;
    justify-content: space-around;
    padding: 16px;
}

.MapProviderContainer__controlDialogOpen__LyFaJ {
    border: 1px solid var(--color-lightui-accent-2);
    box-shadow: 0 0 2px var(--color-darkui-accent-2-80);
    border-radius: 4px;
    width: 320px;
    max-height: 90%;
    min-height: 100px;
    overflow-y: auto;
    overflow-x: hidden;
    top: 39px;
    right: 58px;
    background-color: white;
    position: absolute;
    margin-top: -30px;
    margin-left: -370px;
    z-index: 20001;
    padding: 16px;
}

.MapProviderContainer__controlDialog__eIeFb {
    position: absolute;
    top: 100px;
    left: 100px;
    background-color: white;
    display: none;
}

.MapProviderContainer__layerControlButton__ZUDAN {
    width: 26px;
    height: 30px;
    border-radius: 4px;
    background-size: 18px 18px;
    background-repeat: no-repeat;
    background-position: center center;
    margin-right: 2px;
    cursor: pointer;
}

.MapProviderContainer__layerControlButtonContainer__cabWS {
    background: white;
    margin: 2px;
    margin-top: 0px;
}

.MapProviderContainer__dialogBackdrop__rCw3x {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10000;
    background-color: var(--color-106);
    opacity: .8;
}

.MapProviderContainer__centerMapIcon__qT0PZ {
    background-image: url("data:image/svg+xml,%0A%3Csvg height='16' width='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle cx='8' cy='8' r='5' stroke='%23252525' stroke-width='2'/%3E%3Cg fill='%23252525'%3E%3Cpath d='M13 7h3v2h-3zM0 7h3v2H0zm7-7h2v3H7zm0 13h2v3H7z'/%3E%3Ccircle cx='8' cy='8' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 14px 14px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.2);
    background-color: #fff;
}

.MapProviderContainer__block__9Hwl\\+ {
    margin-bottom: 16px;
}

.MapProviderContainer__checkbox__bwUHI {
    /*TBD if needs custom checkbox*/
}

.MapProviderContainer__anchor__dgLHr a {
    font-size: 12px;
    color: var(--color-blue-primary);
}

.MapProviderContainer__mapLayersContainer__hcpXg {
    padding-top: 8px;
}

.MapProviderContainer__optionLabel__hMxD5 input {
    margin-right: 9px;
}

.MapProviderContainer__surfaceSliderSelection__wqYtR {
    text-align: center;
    font-size: 12px;
}

.MapProviderContainer__sliderLegend__FWJa5 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.MapProviderContainer__legendItem__Iccqp {
    font-size: 12px;
    color: var(--color-secondary);
}

.MapProviderContainer__expandable__wUWPG {
    max-height: 0;
    overflow: hidden;
    transition: all .2s ease-in-out;

    transform-origin: left top;
    transform: scaleY(0);
}

.MapProviderContainer__expandable__wUWPG.MapProviderContainer__expanded__X5hET {
    max-height: 210px;
    overflow: visible;
    transform: scaleY(1);
}

.MapProviderContainer__mapControls__3qCDk {
    position: absolute;
    top: 0;
    width: 100px;
    height: 100px;
    background-color: red;
    display: inline-block;
}

@media only screen and (max-width: 47.9375em) {
    .MapProviderContainer__controlDialogOpen__LyFaJ {
        width: 270px;
        max-width: 67%;
    }
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Maps/components/MapProviderContainer_.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,WAAW;IACX,+pBAA+pB;IAC/pB,kCAAkC;IAClC,4BAA4B;IAC5B,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,cAAc;IACd,UAAU;;AAEd;;AAEA;IACI,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,eAAe;AACnB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,uDAAuD;AAC3D;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,+CAA+C;IAC/C,mDAAmD;IACnD,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;IAClC,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,cAAc;IACd,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,gXAAgX;IAChX,kCAAkC;IAClC,4BAA4B;IAC5B,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,+BAA+B;;IAE/B,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI;QACI,YAAY;QACZ,cAAc;IAClB;AACJ","sourcesContent":[".closeContainer {\n    display: flex;\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    top: 15px;\n    right: 16px;\n}\n\n.closeModalButton {\n    display: inline-block;\n    top: 16px;\n    right: 16px;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!----%3E%3Ctitle%3Eicon-close%3C/title%3E%3Cdesc%3E.%3C/desc%3E%3Cg id='icon-close' stroke='none' stroke-width='1' fill='%23000000' fill-rule='evenodd'%3E%3Cpath d='M6.54545455,8 L-1.59738889e-12,1.45454545 L1.45454545,-1.6442403e-12 L8,6.54545455 L14.5454545,1.65201186e-12 L16,1.45454545 L9.45454545,8 L16,14.5454545 L14.5454545,16 L8,9.45454545 L1.45454545,16 L-1.60249591e-12,14.5454545 L6.54545455,8 Z' id='Combined-Shape' fill='%236c6c6c'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: 16px 16px;\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n}\n\n.closeButton {\n    text-align: center;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10001;\n    opacity: 0;\n\n}\n\n.blockTitle {\n    font: 13px/1em 'Open Sans', sans-serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 300;\n    line-height: 18px;\n    text-transform: capitalize;\n    /*margin-top: 16px;*/\n    /*margin-left: 16px;*/\n}\n.blockLargeFontTitle {\n    font-size: 16px;\n}\n.blockTitleDefaultCase{\n    text-transform: initial;\n}\n\n.mapProviderContainer {\n    display: flex;\n    justify-content: space-around;\n    padding: 16px;\n    border-bottom: 1px solid var(--color-lightui-surface-4);\n}\n\n.mapProviderDropdown {\n    position: relative;\n    z-index: 10001;\n}\n\n.mapTypeContainer {\n    display: flex;\n    justify-content: space-around;\n    padding: 16px;\n}\n\n.controlDialogOpen {\n    border: 1px solid var(--color-lightui-accent-2);\n    box-shadow: 0 0 2px var(--color-darkui-accent-2-80);\n    border-radius: 4px;\n    width: 320px;\n    max-height: 90%;\n    min-height: 100px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    top: 39px;\n    right: 58px;\n    background-color: white;\n    position: absolute;\n    margin-top: -30px;\n    margin-left: -370px;\n    z-index: 20001;\n    padding: 16px;\n}\n\n.controlDialog {\n    position: absolute;\n    top: 100px;\n    left: 100px;\n    background-color: white;\n    display: none;\n}\n\n.layerControlButton {\n    width: 26px;\n    height: 30px;\n    border-radius: 4px;\n    background-size: 18px 18px;\n    background-repeat: no-repeat;\n    background-position: center center;\n    margin-right: 2px;\n    cursor: pointer;\n}\n\n.layerControlButtonContainer {\n    background: white;\n    margin: 2px;\n    margin-top: 0px;\n}\n\n.dialogBackdrop {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 10000;\n    background-color: var(--color-106);\n    opacity: .8;\n}\n\n.centerMapIcon {\n    background-image: url(\"data:image/svg+xml,%0A%3Csvg height='16' width='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle cx='8' cy='8' r='5' stroke='%23252525' stroke-width='2'/%3E%3Cg fill='%23252525'%3E%3Cpath d='M13 7h3v2h-3zM0 7h3v2H0zm7-7h2v3H7zm0 13h2v3H7z'/%3E%3Ccircle cx='8' cy='8' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: 14px 14px;\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    cursor: pointer;\n    border: 1px solid rgba(0,0,0,0.2);\n    background-color: #fff;\n}\n\n.block {\n    margin-bottom: 16px;\n}\n\n.checkbox {\n    /*TBD if needs custom checkbox*/\n}\n\n.anchor a {\n    font-size: 12px;\n    color: var(--color-blue-primary);\n}\n\n.mapLayersContainer {\n    padding-top: 8px;\n}\n\n.optionLabel input {\n    margin-right: 9px;\n}\n\n.surfaceSliderSelection {\n    text-align: center;\n    font-size: 12px;\n}\n\n.sliderLegend {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 10px;\n}\n\n.legendItem {\n    font-size: 12px;\n    color: var(--color-secondary);\n}\n\n.expandable {\n    max-height: 0;\n    overflow: hidden;\n    transition: all .2s ease-in-out;\n\n    transform-origin: left top;\n    transform: scaleY(0);\n}\n\n.expandable.expanded {\n    max-height: 210px;\n    overflow: visible;\n    transform: scaleY(1);\n}\n\n.mapControls {\n    position: absolute;\n    top: 0;\n    width: 100px;\n    height: 100px;\n    background-color: red;\n    display: inline-block;\n}\n\n@media only screen and (max-width: 47.9375em) {\n    .controlDialogOpen {\n        width: 270px;\n        max-width: 67%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeContainer": `MapProviderContainer__closeContainer__l9V-e`,
	"closeModalButton": `MapProviderContainer__closeModalButton__6d9dI`,
	"closeButton": `MapProviderContainer__closeButton__La7s6`,
	"blockTitle": `MapProviderContainer__blockTitle__ROnd1`,
	"blockLargeFontTitle": `MapProviderContainer__blockLargeFontTitle__cgMKi`,
	"blockTitleDefaultCase": `MapProviderContainer__blockTitleDefaultCase__zS16w`,
	"mapProviderContainer": `MapProviderContainer__mapProviderContainer__q1NNw`,
	"mapProviderDropdown": `MapProviderContainer__mapProviderDropdown__YnPBB`,
	"mapTypeContainer": `MapProviderContainer__mapTypeContainer__LTCpg`,
	"controlDialogOpen": `MapProviderContainer__controlDialogOpen__LyFaJ`,
	"controlDialog": `MapProviderContainer__controlDialog__eIeFb`,
	"layerControlButton": `MapProviderContainer__layerControlButton__ZUDAN`,
	"layerControlButtonContainer": `MapProviderContainer__layerControlButtonContainer__cabWS`,
	"dialogBackdrop": `MapProviderContainer__dialogBackdrop__rCw3x`,
	"centerMapIcon": `MapProviderContainer__centerMapIcon__qT0PZ`,
	"block": `MapProviderContainer__block__9Hwl+`,
	"checkbox": `MapProviderContainer__checkbox__bwUHI`,
	"anchor": `MapProviderContainer__anchor__dgLHr`,
	"mapLayersContainer": `MapProviderContainer__mapLayersContainer__hcpXg`,
	"optionLabel": `MapProviderContainer__optionLabel__hMxD5`,
	"surfaceSliderSelection": `MapProviderContainer__surfaceSliderSelection__wqYtR`,
	"sliderLegend": `MapProviderContainer__sliderLegend__FWJa5`,
	"legendItem": `MapProviderContainer__legendItem__Iccqp`,
	"expandable": `MapProviderContainer__expandable__wUWPG`,
	"expanded": `MapProviderContainer__expanded__X5hET`,
	"mapControls": `MapProviderContainer__mapControls__3qCDk`
};
export default ___CSS_LOADER_EXPORT___;
